module.exports = __webpack_public_path__ + "static/clip-644ca145a5d9f8d609b0b009b950133f.gif";